{
  "dashboard": {
    "navigation_title": "Paneles de control",
    "title": "Panel de control",
    "report_title_placeholder": "<enter report name>",
    "no_widgets": "¡Aún no se crearon widgets!",
    "add_widget": "Agregar widget",
    "access_denied": "Lo sentimos. No tiene acceso al panel de control.",
    "default_title": "Panel de control",
    "max_number_of_widgets_reached": "Lo sentimos.... ¡No pueden añadirse más de %{widget_number} widgets!",
    "chart_no_data": "No hay datos para mostrar",
    "chart_no_parameters_selected": "Por favor seleccione un parámetro",
    "nodes_no_data": "No hay datos para mostrar",
    "thiamis_online": "Thiamis en línea",
    "devices_online": "Dispositivos en línea (24H)",
    "total_devices": "Dispositivos totales",
    "users_online": "Usuarios en línea",
    "active_alerts": "Alertas activas",
    "widget_removed": "Debido a la pérdida de acceso, el widget se eliminó",
    "time": {
      "30_min": "Últimos 30 minutos",
      "1_hour": "Última hora",
      "1_day": "Último día",
      "hours": "Últimas %{hours} horas",
      "days": "Últimos %{hours} días",
      "last_day": "Último día",
      "yesterday": "Ayer",
      "last_week": "Última semana"
    }
  }
}
